import { Alert, Button, Snackbar } from '@mui/material';
import { useState } from 'react';
import { ApiError } from '@/lib/api-client';
import { clearUndo, useUndoOffer } from '@/lib/undo';

/** The one Undo bar for the whole app, for removed files and deleted records. */
export function UndoBar() {
  const offer = useUndoOffer();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  const undo = async () => {
    if (!offer) return;
    setBusy(true);
    try {
      await offer.undo();
    } catch (e) {
      // The server says why it cannot go back (the window closed, a limit is reached, the record is locked).
      setError(e instanceof ApiError ? e.detailMessage : 'Undo failed.');
    } finally {
      setBusy(false);
      clearUndo();
    }
  };

  return (
    <>
      <Snackbar key={offer?.id} open={!!offer} autoHideDuration={10_000} message={offer?.message}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                onClose={(_e, why) => { if (why !== 'clickaway' && !busy) clearUndo(); }}
                action={<Button color="inherit" size="small" disabled={busy} onClick={undo}>Undo</Button>} />
      <Snackbar open={!!error} autoHideDuration={8_000} onClose={() => setError(undefined)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <Alert severity="error" variant="filled" onClose={() => setError(undefined)}>{error}</Alert>
      </Snackbar>
    </>
  );
}
